import { useRef } from 'react';
import styles from './CaseStudy.module.scss';
import TitleFlex from 'components/services/commons/TitleFlex';
import AutoSliderNew from 'components/home/CaseStudy/AutoSliderNew';
import Button from 'components/commons/Button/Button';
import animationStyles from 'components/commons/Animation/Animation.module.scss';
import useElementVisible from 'components/commons/Animation/useElementVisible';

const CaseStudyNew: React.FC = () => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const slideRef = useRef<HTMLDivElement>(null);
  const isButtonVisible = useElementVisible(buttonRef, 0.1);
  const isSlideVisible = useElementVisible(slideRef, 0.1);

  return (
    <section className={styles.wrapper}>
      <div className={styles.inner}>
        <TitleFlex
          sectionTitle={{
            title: 'Case study',
            sub_title: '事例',
          }}
        />
      </div>
      <div className={`${styles.autoSlider} ${animationStyles.fade} ${isSlideVisible ? animationStyles.fadeOn : ''} autoSlider`} ref={slideRef}>
        <AutoSliderNew />
      </div>
      <div className={`${styles.inner} Case_btn`}>
        <div
          className={`${styles.btn} ${animationStyles.fade} ${isButtonVisible ? animationStyles.fadeOn : ''}`}
          ref={buttonRef}
        >
          <Button text="事例一覧" href="/cases" />
        </div>
      </div>
    </section>
  );
};

export default CaseStudyNew;